import axios from '@/components/api/axios';

async function getCreditCardList(bc) {
  let data = {
    bcNo: bc
  };
  const res = await axios.axiosGet('/api/creditCards/getList', data);
  return res;
}

async function addCreditCard(token) {
  console.log(token);
  const data = {
    transactionToken: token
  };
  const res = await axios.axiosPost('/api/creditCards/add', data);
  return res;
}

async function updateCreditCard(bcNo, creditCardId, sameWithBc001) {
  let data = {
    bcNo: bcNo,
    creditCardId: creditCardId,
    sameWithBc001: sameWithBc001,
    // sameWithBc001: true,
  };
  console.log(data);
  const res = await axios.axiosPut('/api/creditCards/updateDefaultBc', data);
  return res;
}

export default {
  getCreditCardList,
  addCreditCard,
  updateCreditCard
}



// WEBPACK FOOTER //
// ./src/components/api/creditCard.js